import { ARTIFACT_MIN_WIDTH_PX } from "../geometry/panel-metrics"

export const EXPLORER_RAIL_WIDTH_PX = 212

export const EXPLORER_RAIL_MIN_WIDTH_PX = EXPLORER_RAIL_WIDTH_PX + ARTIFACT_MIN_WIDTH_PX

export const EXPLORER_CONTAINER_NAME = "kelly-skill-package"

export const WIDE_EXPLORER_QUERY = `@container ${EXPLORER_CONTAINER_NAME} (min-width: ${EXPLORER_RAIL_MIN_WIDTH_PX}px)`
